<div class="file-list">
  @if (isLoading) {
    <div class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  }

  @if (attachmentDisplayType !== 'radio') {
    @for (attachment of attachments; track trackByAttachmentId($index, attachment)) {
      <div class="file-item" (click)="toggleSelection(attachment.id)" (keydown.enter)="toggleSelection(attachment.id)" tabindex="0" role="button">
        @if (attachmentDisplayType === 'checkbox') {
          <mat-checkbox [checked]="isSelected(attachment.id)" (change)="toggleSelection(attachment.id)" (click)="$event.stopPropagation()" class="file-checkbox">
            <span class="file-name" (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()" tabindex="0" role="button">
              {{ attachment.friendlyFileName }}
            </span>
          </mat-checkbox>
        } @else {
          <span class="file-name-no-checkboxes" (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()" tabindex="0" role="button">
            {{ attachment.friendlyFileName }}
          </span>
        }

        <div class="preview-container">
          <button class="preview-button" [style.visibility]="isSelected(attachment.id) ? 'visible' : 'hidden'" (click)="previewFile(attachment.id); $event.stopPropagation()">Preview</button>
        </div>
      </div>
    }
  } @else {
    <mat-radio-group [value]="selectedFiles.values().next().value" (change)="toggleSelection($event.value)">
      @for (attachment of attachments; track trackByAttachmentId($index, attachment)) {
        <div class="file-item" (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()" tabindex="0" role="button">
          <mat-radio-button [value]="attachment.id" class="file-checkbox">
            <span class="file-name">{{ attachment.friendlyFileName }}</span>
          </mat-radio-button>
          <div class="preview-container">
            @if (isSelected(attachment.id)) {
              <button class="preview-button" (click)="previewFile(attachment.id); $event.stopPropagation()">Preview</button>
            }
          </div>
        </div>
      }
    </mat-radio-group>
  }
</div>
